import { createFileRoute } from '@tanstack/react-router';

import { ChatPage } from '@/_pages/question-generators';

export const Route = createFileRoute('/question-generator/')({
  component: ChatPage,
});
